/* FanGlow™: one shared cart-checkbox product and product-info checkbox. */
(function () {
  'use strict';
  if (window.FaneclatSyncedUpsell) return;

  const selector = '[data-faneclat-upsell-control]';
  const staged = new Map();
  let currentCart = null;
  let refreshPromise = null;
  let isUpdating = false;

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function cartURL(suffix) {
    if (window.routes && window.routes.cart_url) return window.routes.cart_url + suffix;
    return getRoot() + 'cart' + suffix;
  }
  function apiURL(name) {
    if (window.routes && window.routes[name]) return window.routes[name];
    return getRoot() + ({cart_add_url:'cart/add', cart_change_url:'cart/change'}[name] || 'cart');
  }
  function controls() {
    return Array.from(document.querySelectorAll(selector));
  }
  function variantId() {
    const field = controls().find(input => input.dataset.faneclatUpsellVariantId);
    return field ? String(field.dataset.faneclatUpsellVariantId) : null;
  }
  function existingLine(cart, id) {
    if (!cart || !Array.isArray(cart.items)) return null;
    const candidates = cart.items.filter(item => String(item.variant_id) === String(id));
    // Prefer a checkbox-added line if the same variant was separately purchased.
    return candidates.find(item => item.properties && item.properties._faneclat_upsell === '1') || candidates[0] || null;
  }
  async function readCart() {
    const response = await fetch(cartURL('.js'), {
      credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}
    });
    if (!response.ok) throw new Error('Unable to load your cart.');
    return response.json();
  }
  function showError(message) {
    document.querySelectorAll('[data-faneclat-upsell-error]').forEach(node => {
      node.textContent = message || 'Unable to update this option.';
      node.hidden = false;
    });
    if (!document.querySelector('[data-faneclat-upsell-error]')) console.warn('FanGlow™:',message);
  }
  function clearError() {
    document.querySelectorAll('[data-faneclat-upsell-error]').forEach(node => {
      node.textContent = '';
      node.hidden = true;
    });
  }
  function reflect(cart) {
    const id = variantId();
    if (!id) return;
    const found = Boolean(existingLine(cart, id));
    controls().forEach(input => {
      if (String(input.dataset.faneclatUpsellVariantId) !== id) return;
      const isProduct = input.dataset.faneclatUpsellSource === 'product';
      if (found) {
        input.checked = true;
      } else if (isProduct && cart.item_count === 0) {
        input.checked = staged.has(id) ? staged.get(id) : input.dataset.preselected === 'true';
      } else {
        input.checked = false;
      }
    });
  }
  async function refresh() {
    if (isUpdating) return currentCart;
    if (refreshPromise) return refreshPromise;
    refreshPromise = readCart().then(cart => {
      currentCart = cart;
      reflect(cart);
      clearError();
      return cart;
    }).catch(error => {
      console.warn('FanGlow™ sync:', error);
      return currentCart;
    }).finally(() => {refreshPromise = null;});
    return refreshPromise;
  }
  async function writeCart(path, payload) {
    const response = await fetch(apiURL(path), {
      method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify(payload)
    });
    const result = await response.json();
    if (!response.ok || result.status || result.errors)
      throw new Error(result.description || result.message || 'Unable to update your cart.');
    return result;
  }
  function activeDrawer() {return document.querySelector('cart-drawer');}
  function requiredSections(drawer) {
    return drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(section => section.id)
      : ['cart-drawer','cart-icon-bubble'];
  }
  async function renderCart(data, id, sectionNames) {
    const drawer = activeDrawer();
    if (drawer && typeof drawer.renderContents === 'function') {
      let sections = data.sections;
      if (!sections || !sectionNames.every(key => sections[key])) {
        const url = new URL(cartURL(''),window.location.origin);
        url.searchParams.set('sections',sectionNames.join(','));
        const response = await fetch(url.toString(),{credentials:'same-origin'});
        if (!response.ok) throw new Error('Unable to refresh your cart.');
        sections = await response.json();
      }
      if (!sections || !sectionNames.every(key => sections[key]))
        throw new Error('Unable to refresh your cart.');
      drawer.renderContents({id:Number(id),sections});
      return;
    }
    // A full cart page lacks the drawer. Refresh it so totals and checkout stay correct.
    window.location.reload();
  }
  async function applyControl(input, isChecked) {
    const id = String(input.dataset.faneclatUpsellVariantId || '');
    if (!id || isUpdating) return;
    staged.set(id,isChecked);
    clearError();
    controls().filter(node => String(node.dataset.faneclatUpsellVariantId) === id).forEach(node => node.checked=isChecked);
    isUpdating = true;
    let modified = false;
    try {
      const cart = await readCart();
      currentCart = cart;
      const line = existingLine(cart,id);
      const productSource = input.dataset.faneclatUpsellSource === 'product';
      if (productSource && cart.item_count === 0) return; // Slechts stage the first preselected upsell.
      if (Boolean(line) === isChecked) return; // Never add an existing variant twice.
      controls().forEach(node => node.disabled=true);
      const names = requiredSections(activeDrawer());
      let result;
      if (isChecked) {
        result = await writeCart('cart_add_url', {
          items:[{id:Number(id),quantity:1,properties:{_faneclat_upsell:'1'}}],
          sections:names,sections_url:window.location.pathname
        });
      } else {
        // Use Shopify's unique line-item key so only this entry is removed.
        result = await writeCart('cart_change_url', {
          id:line.key,quantity:0,sections:names,sections_url:window.location.pathname
        });
      }
      modified = true;
      await renderCart(result,id,names);
      currentCart = await readCart();
    } catch (error) {
      showError(error.message);
      if (modified) {
        // Successful cart modification but a rendering error: reload to avoid a duplicate action.
        window.location.reload();
        return;
      }
    } finally {
      isUpdating = false;
      controls().forEach(node => node.disabled=false);
      if (currentCart) reflect(currentCart);
      if (!modified) refresh();
    }
  }

  document.addEventListener('change',function(event) {
    const input = event.target;
    if (!input || !input.matches || !input.matches(selector)) return;
    // The theme's cart-items component would misread this as a quantity change.
    event.stopImmediatePropagation();
    applyControl(input,input.checked);
  },true);

  document.addEventListener('DOMContentLoaded',refresh);
  document.addEventListener('shopify:section:load',refresh);
  // Other cart mutations (quantity, recommendations) publish this Shopify theme event.
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate,() => setTimeout(refresh,30));
  }
  window.FaneclatSyncedUpsell={refresh,showError,readCart};
})();
